import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

export const fetchBlockTest = () => {
  return new ServicesUseCase(
    `/aplicacaoTeste/loadConstrutos/loadBlocos`,
    makeAxiosHttpClient()
  )
}
